import { render, staticRenderFns } from "./LoginMini.vue?vue&type=template&id=55e1b1e6"
import script from "./LoginMini.vue?vue&type=script&lang=js"
export * from "./LoginMini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports